import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Spin } from 'react-burgers'

export default class Burger extends Component {
  state = {
    active: false
  }
  handleOnClick = () => {
    const el = document.getElementById('site-navigation')
    el.classList.toggle('open')
    this.setState({
      active: !this.state.active
    })
  }
  componentDidMount() {
    const el = document.getElementById('site-navigation')
    el.addEventListener('click', () => {
      el.classList.toggle('open')
      this.setState({
        active: false
      })
    })
  }
  render() {
    return <Spin active={this.state.active} onClick={this.handleOnClick} />
  }
}

ReactDOM.render(<Burger />, document.querySelector('#hamburger'))
